import { render } from "./ModalAfficherAppMethode.vue?vue&type=template&id=3665d112&scoped=true"
import script from "./ModalAfficherAppMethode.vue?vue&type=script&lang=js"
export * from "./ModalAfficherAppMethode.vue?vue&type=script&lang=js"

import "./ModalAfficherAppMethode.vue?vue&type=style&index=0&id=3665d112&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3665d112"]])

export default __exports__